module.exports = __webpack_public_path__ + "static/media/final.6eca845d.png";